import { GetTokenSilentlyOptions } from '@auth0/auth0-react';

import { VITE_AUTH0_AUDIENCE } from '~/lib/constants/env';

/**
 * @deprecated
 * (arbitrary) format for listener enums and values:
 *   enum:  [listening_component]_[emitting_component]_[action]
 *   value: [listening_component]::[emitting_component]::[action]
 */
export enum Listeners {
  APPOINTMENTS_NOTE_REFRESH = 'Appointments::Note::Refresh',
  PATIENTMENU_TASKDETAILS_CREATE = 'PatientMenu::TaskDetails::Create',
  PATIENTMENU_TASKDETAILS_UPDATE = 'PatientMenu::TaskDetails::Update',
  PATIENTPROFILE_PATIENTBASICINFO_UPDATE = 'PatientProfile::PatientBasicInfo::Update',
  PATIENTTASKS_TASKDETAILS_CREATE = 'PatientTasks::TaskDetails::Create',
  PATIENTTASKS_TASKDETAILS_UPDATE = 'PatientTasks::TaskDetails::Update',
}

export enum GlobalErrorCode {
  ADD_GROUP_CLASS_EVENT_HOST = 'ADD_GROUP_CLASS_EVENT_HOST',
  CANCEL_GROUP_CLASS_EVENT = 'CANCEL_GROUP_CLASS_EVENT',
  CREATE_INQUIRY_V2 = 'CREATE_INQUIRY_V2',
  EDIT_INQUIRY_V2 = 'EDIT_INQUIRY_V2',
  CONFIRM_PATIENT = 'CONFIRM_PATIENT',
  FETCH_DUPLICATE_CONTACTS = 'FETCH_DUPLICATE_CONTACTS',
  FETCH_DUPLICATE_COVERAGES = 'FETCH_DUPLICATE_COVERAGES',
  GET_CARE_TEAM = 'GET_CARE_TEAM',
  GET_GROUP_CLASS_EVENT_DETAILS = 'GET_GROUP_CLASS_EVENT_DETAILS',
  GET_GROUP_CLASS_EVENT_MEETING_DETAILS = 'GET_GROUP_CLASS_EVENT_MEETING_DETAILS',
  GET_GROUP_CLASS_EVENT_NOTES = 'GET_GROUP_CLASS_EVENT_NOTES',
  GET_ZOOM_MEETING_DETAILS = 'GET_ZOOM_MEETING_DETAILS',
  INQUIRY_NOT_FOUND = 'INQUIRY_NOT_FOUND',
  MERGE_DUPLICATE_CONTACTS = 'MERGE_DUPLICATE_CONTACTS',
  MODIFY_GROUP_CLASS_EVENT_ATTENDEES = 'MODIFY_GROUP_CLASS_EVENT_ATTENDEES',
  SAVE_APPOINTMENT = 'SAVE_APPOINTMENT',
  SET_PATIENT_ACTIVE = 'SET_PATIENT_ACTIVE',
  UPDATE_INQUIRY_ASSIGNMENTS = 'UPDATE_INQUIRY_ASSIGNMENTS',
  UPDATE_CARE_TEAM = 'UPDATE_CARE_TEAM',
  ZOOM_USER_DOES_NOT_EXIST = 'ZOOM_USER_DOES_NOT_EXIST',
  VOID_NOTE = 'VOID_NOTE',
  UPDATE_INQUIRY_REVIEWS = 'UPDATE_INQUIRY_REVIEWS',
  UPDATE_NEXT_STEPS = 'UPDATE_NEXT_STEPS',
  CREATE_ATTRIBUTES = 'CREATE_ATTRIBUTES',
  UNPIN_MESSAGE = 'UNPIN_MESSAGE',
  CREATE_TREATMENT_PATHWAY = 'CREATE_TREATMENT_PATHWAY',
  CREATE_QOL_GOAL = 'CREATE_QOL_GOAL',
  UPDATE_QOL_GOAL = 'UPDATE_QOL_GOAL',
  CREATE_CUSTOM_INTERVENTIONS = 'CREATE_CUSTOM_INTERVENTIONS',
  VOID_CUSTOM_INTERVENTION = 'VOID_CUSTOM_INTERVENTION',
}

export const GLOBAL_GENERIC_ERROR_TEXT =
  "We're sorry, we are unable to complete the action at this time. Please try again or reach out to";

export const SUPPORT_EMAIL = 'support@equip.health';
export const auth0SilentTokenOptions: GetTokenSilentlyOptions = {
  authorizationParams: {
    audience: VITE_AUTH0_AUDIENCE,
    scope: 'offline_access',
  },
};

export enum AppAccess {
  MAUD = 'Maud',
  ADMIN = 'Admin',
  OPS = 'Ops',
}
